/* eslint-disable unicorn/filename-case */
import { type Theme } from '@mui/material';
import { type SystemStyleObject } from '@mui/system';
import { SvgContainer } from './styled.ts';

export type BbfcPGProps = {
  height?: number;
  sx?: SystemStyleObject<Theme>;
  width?: number;
};

export const BbfcPG = ({ height = 35, sx, width = 35 }: BbfcPGProps) => (
  <SvgContainer height={height} sx={sx} viewBox="0 0 92.604 82.496" width={width} xmlns="http://www.w3.org/2000/svg">
    <defs>
      <clipPath id="a">
        <path d="M126.754 273.902h62.84v55.985h-62.84zm0 0" />
      </clipPath>
    </defs>
    <g
      clipPath="url(#a)"
      style={{ opacity: 1, stopOpacity: 1 }}
      transform="matrix(1.47365 0 0 1.47365 -186.791 -403.637)"
    >
      <path
        d="M187.945 326.453a4.844 4.844 0 0 1-4.242 2.45h-51.058a4.85 4.85 0 0 1-4.247-2.45 4.868 4.868 0 0 1 0-4.902l25.532-44.219a4.849 4.849 0 0 1 4.242-2.45 4.85 4.85 0 0 1 4.246 2.45l25.527 44.219a4.85 4.85 0 0 1 0 4.902m.852-5.394-25.527-44.215a5.825 5.825 0 0 0-5.098-2.942 5.823 5.823 0 0 0-5.094 2.938l-25.531 44.219a5.818 5.818 0 0 0 .004 5.882 5.819 5.819 0 0 0 5.094 2.942h51.058a5.819 5.819 0 0 0 5.094-2.942 5.827 5.827 0 0 0 0-5.882"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
    </g>
    <path
      d="M183.703 326.445h-51.058c-1.883 0-3.06-2.035-2.118-3.668l25.528-44.215a2.42 2.42 0 0 1 2.117-1.222c.824 0 1.648.406 2.121 1.223l25.527 44.214c.942 1.633-.234 3.668-2.117 3.668m4.242-4.894-25.527-44.219a4.85 4.85 0 0 0-4.246-2.45c-1.77 0-3.36.915-4.246 2.45l-25.528 44.219a4.84 4.84 0 0 0 .004 4.902 4.844 4.844 0 0 0 4.243 2.45h51.058c1.77 0 3.356-.915 4.242-2.45a4.85 4.85 0 0 0 0-4.902"
      style={{
        fill: '#fff',
        fillOpacity: 1,
        fillRule: 'nonzero',
        opacity: 1,
        stopOpacity: 1,
        stroke: 'none',
      }}
      transform="matrix(1.47365 0 0 1.47365 -186.791 -403.637)"
    />
    <path
      d="M160.293 278.563a2.427 2.427 0 0 0-2.121-1.223c-.82 0-1.645.406-2.117 1.223l-25.528 44.214c-.941 1.633.235 3.668 2.118 3.668h51.058c1.883 0 3.059-2.035 2.117-3.668zm0 0"
      style={{
        fill: '#fab800',
        fillOpacity: 1,
        fillRule: 'nonzero',
        opacity: 1,
        stopOpacity: 1,
        stroke: 'none',
      }}
      transform="matrix(1.47365 0 0 1.47365 -186.791 -403.637)"
    />
    <path
      d="M143.39 302.8h6.298c1.03 0 2.117 0 3.203.294 1.824.504 4.39 2.144 4.39 5.926 0 2.488-1.164 5.16-4.496 5.902-1.035.238-2.012.238-3.152.238h-2.723v6.324h-3.52zm3.52 2.993v6.484h2.512c.742 0 1.375 0 1.984-.16 2.172-.531 2.301-2.515 2.301-3.176 0-1.375-.605-2.09-.922-2.382-.875-.739-2.094-.766-3.23-.766zM175.102 311.27v10.214h-2.993v-1.59c-1.664 1.641-3.543 2.067-5.105 2.067-5.766 0-8.809-4.606-8.809-9.633 0-5.875 3.887-10 9.02-10 3.89 0 6.75 2.379 7.887 5.504l-3.336 1.348c-.344-1.032-1.348-3.703-4.524-3.703-3.52 0-5.238 3.066-5.238 6.746 0 4.101 2.25 6.457 5.289 6.457 1.96 0 4.289-1.032 4.605-4.34h-4.656v-3.07zm0 0"
      style={{
        fill: '#fff',
        fillOpacity: 1,
        fillRule: 'nonzero',
        opacity: 1,
        stopOpacity: 1,
        stroke: 'none',
      }}
      transform="matrix(1.47365 0 0 1.47365 -186.791 -403.637)"
    />
  </SvgContainer>
);
